


function Login() {
    return(
        <p>Login component for people</p>

    );
}

export default Login;